import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import "./signinsignup.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { MyGlobalContext } from "../../Context";

const Signin = () => {
  const { setRunToken } = MyGlobalContext();
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({
    mobile: "",
    password: "",
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const toggleOnClickVisible = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const inputStyle = { width: "100%", maxWidth: "240px" };

  //   onChange inputs
  const inputChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prev) => {
      return { ...prev, [name]: value };
    });
  };

  //   destructruing the input values
  const { mobile, password } = inputValues;

  const toastStyle = { position: "top-center", autoClose: 1500 };
  //   handling the login submit form
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    if (!mobile || !password) {
      toast.warn("Can't submit, please fill all the inputs!", toastStyle);
    } else {
      axios
        .post("https://cocktailshop.onrender.com/login", { mobile, password })
        .then((res) => {
          if (res.status === 201) {
            localStorage.setItem("CocktailToken", res.data.token);
            toast.success(res.data.message, toastStyle);
            setInputValues({
              mobile: "",
              password: "",
            });
            setRunToken(1)
            navigate("/profile");
          }
        })
        .catch((err) => {
          //   console.log(err);
          const status = err.response.status;
          const message = err.response.data.message;
          if (status === 500) {
            toast.warn(message, toastStyle);
          } else {
            toast.warn(message, toastStyle);
          }
        });
    }
  };
  return (
    <form onSubmit={handleLoginSubmit} className="login-form w-3/4 mx-auto">
      <h1 className="text-center font-extrabold text-2xl form-h1 mt-4 text-blue-900">
        Login
      </h1>
      <div className=" w-20 h-1 bg-gradient-to-r from-blue-900 to-pink-900 mt-2 mx-auto rounded"></div>
      <p className="text-center font-bold text-gray-600 my-6">
        Welcome back! Login to your account and <br></br> eligible to buy drink
      </p>

      <div className="w-full text-center">
        <div className="mx-auto" style={inputStyle}>
          <TextField
            label="Mobile"
            type="number"
            name="mobile"
            variant="standard"
            value={inputValues.mobile}
            onChange={inputChange}
            sx={inputStyle}
          />
        </div>
        <div className="relative mx-auto" style={inputStyle}>
          <TextField
            label="Password"
            type={isPasswordVisible ? "text" : "password"}
            name="password"
            variant="standard"
            value={inputValues.password}
            onChange={inputChange}
            sx={inputStyle}
            autoComplete="off"
          />
          <span
            onClick={toggleOnClickVisible}
            className="absolute bottom-2 right-2 cursor-pointer text-xl hover:text-blue-500"
          >
            {isPasswordVisible ? <AiFillEye /> : <AiFillEyeInvisible />}
          </span>
        </div>
        <button
          type="submit"
          className="mt-7 py-1 flex justify-center items-center mx-auto rounded hover:text-amber-500 font-extrabold  btn-login"
        >
          <BsArrowRightCircleFill style={{ marginRight: "5px" }} /> Continue
        </button>
        <p className=" font-semibold mt-2">
          Don't have account!
          <Link
            to="/register"
            className=" text-blue-400 hover:text-blue-700 hover:underline"
          >
            Register Now
          </Link>
        </p>
      </div>
    </form>
  );
};

export default Signin;
